import { configuracionApi } from '@/api';
import Configuracion from '@/model/Configuracion';

export default class ConfiguracionService {

    save(configuracion: Configuracion): Promise<Configuracion> {

            return configuracionApi.save(configuracion);
        
    }
    
    get(): Promise<Configuracion> {
        return configuracionApi.get();
    }
    
 

}